import Dropdown from 'react-dropdown';
import React, { Component } from 'react';
import Tone from 'tone';
import EffectParameterSlider from './EffectParameterSlider.js';

class AutoFilterEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterEffect: props.filterEffect,
            frequency: props.filterEffect.getStoredLFOTime(),
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.filterEffect = nextProps.filterEffect;
        return true;
    }

    handleOptionChange(evt) {
        if (evt.target.value === 'lowpass') {
            this.state.filterEffect.lowpass();
        } else {
            this.state.filterEffect.hipass();
        }
        this.setState(this.state);
    }

    handleLFOTimeChange(lfoTime) {
        this.state.frequency = lfoTime;
        this.state.filterEffect.setLFOTime(lfoTime());
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.filterEffect.isEnabled();
    }

    render() {
        var type = this.state.filterEffect.getFilterType();
        var lfoTime= this.state.filterEffect.getLFOTime();
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.filterEffect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
              <div>
                <form>
                <div className="radio">
                  <label>
                    <input className="filter-radio"
                           type="radio"
                           value="lowpass"
                           checked={type === 'lowpass'}
                           onChange={(e) => this.handleOptionChange(e)} />
                    Lowpass
                  </label>
                  <label>
                    <input className="filter-radio"
                           type="radio"
                           value="hipass"
                           checked={type === 'highpass'}
                           onChange={(e) => this.handleOptionChange(e)} />
                    Hipass 
                  </label>
                  <Dropdown
                        className='delay-time-dropdown'
                        options={lfoTimeOptions}
                        onChange={(o) => this.handleLFOTimeChange(o.value)}
                        value={getLFOTimeOption(this.state.frequency)}
                        placeholder="Delay Time" />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Cutoff'
                        unit={'HZ'}
                        parameter={this.state.filterEffect.effectNode.baseFrequency}
                        onParameterChanged={this.props.onParameterChanged}
                        updateFunction={(cutoff) => this.state.filterEffect.effectNode.baseFrequency = cutoff}
                        getValue={() => this.state.filterEffect.effectNode.baseFrequency}
                        step={5}
                        max={10000}
                        min={10}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Octaves'
                        parameter={this.state.filterEffect.effectNode.octaves}
                        updateFunction={(octaves) => this.state.filterEffect.effectNode.octaves = octaves}
                        onParameterChanged={this.props.onParameterChanged}
                        getValue={() => this.state.filterEffect.effectNode.octaves}
                        step={0.1}
                        max={10}
                        min={0}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Q'
                        parameter={this.state.filterEffect.qParameter}
                         onParameterChanged={this.props.onParameterChanged}
                         isParameter={true}
                        step={1}
                        max={10}
                        min={0}
                        />
                    </div>
                  </form>
                  </div>
                  }
            </div>
        );
    }
}

const lfoTimeOptions = [
    {value: () => 0.03125 * new Tone.Time('1m'), label:'4'}, 
    {value: () => 0.125 * new Tone.Time('1m'), label:'2'}, 
    {value: () => 0.25 * new Tone.Time('1m'), label:'1'}, 
    {value: () => 0.5 * new Tone.Time('1m'), label:'1/2'}, 
    {value: () =>  0.5 * new Tone.Time('2m'), label:'1/4'}, 
     {value: () => 2 * new Tone.Time('1m'), label:'1/8'}, 
     {value: () => 3 * new Tone.Time('1m'), label:'1/8t'}, 
     {value: () => 4 * new Tone.Time('1m'), label:'1/16'}, 
     {value: () => 6 * new Tone.Time('1m'), label:'1/16t'}, 
     {value: () => 8 * new Tone.Time('1m'), label:'1/32'}, 
];

function getLFOTimeOption(value) {
    value = typeof value === 'function' ? value() : value;
    var options = lfoTimeOptions.filter((opt) =>
                                        {
                                            return    opt.value() === value;
                                        });
    if (options.length == 0) {
        return lfoTimeOptions[0];
    }
    return options[0];
}

export default AutoFilterEffect;
